module.exports = __webpack_public_path__ + "static/media/logo_final.824d965d.svg";